import React from "react";
import { cn } from "tailwind-variants";
import Sizes from "./Sizes.vue";
import Variants from "./Variants.vue";
import GangSheetBuilderButton from "./GangSheetBuilderButton.vue";
import UploadGangSheet from "./UploadGangSheet.vue";
import "./GangSheetBuilderPdpContainer.scss";

export default function GangSheetBuilderPdpContainer({ currentStore, ...restProps }) {
  return (
    <div {...restProps} className={cn("gang-sheet-builder-container")}>
      <Sizes data-testid="sizes" />
      <Variants data-testid="variants" />
      <GangSheetBuilderButton data-testid="gang-sheet-builder-button" />
      <UploadGangSheet currentStore={currentStore} data-testid="upload-gang-sheet" />
    </div>
  );
}
